import { render } from "./CurrentPageReport.vue?vue&type=template&id=57085f26"
import script from "./CurrentPageReport.vue?vue&type=script&lang=js"
export * from "./CurrentPageReport.vue?vue&type=script&lang=js"
script.render = render

export default script